<template>
  <div class="container">

    <div class="container text m-t-1-sm m-b-3-sm m-y-2-md">
      <h1 class="titulo m-t-2 m-t-3-md">Balance Nacional de Energía</h1>
      <hr>
      <p class="texto-principal">El Balance Nacional de Energía analiza el flujo de cada uno de los energéticos a través de los distintos procesos de la cadena energética. Ésta inicia con los recursos energéticos primarios, como el gas natural, la radiación solar o la hidroenergía. Estos recursos pasan por procesos de transformación para obtener energéticos secundarios. Ambos energéticos se transportan y distribuyen hasta el usuario final para su consumo, cabe destacar que de acuerdo con la primera ley de la termodinámica en cada transformación de una forma de energía a otra se producen pérdidas, lo que reduce la disponibilidad energética para el consumo final.</p>
    </div>

      <div class="tarjeta-contenedor">
        <div class="encabezado">
          <h3>Balance Nacional de Energía</h3>
          <p class="texto-notas">Datos en petajoules (PJ)</p>
          <p class="texto-notas">Instrucciones: Pasa el cursor por los nodos o enlaces para resaltar las conexiones y los flujos.</p>
        </div>
        <div class="contenido">
          
          <div class="container" id="sankey-balance">
            <svg ref="svg"></svg>
          </div>

        </div>
          <div class="notas">
            
              <button type="submit" onclick="window.open('../descarga/balance/energia_planeas_bne_flujo_2020.csv')" class="descargar-datos">Descargar datos <img src="@/assets/img/descargar.svg" alt=""></button>
            
          </div>
      </div>
      
      <br>

      <div class="tarjeta-contenedor">
        <div class="encabezado">
          <h3>Balance Nacional de Energía 2020</h3>
          <p class="texto-notas">Datos en petajoules (PJ)</p>
        </div>
        <div class="contenido">
          
         <div id="graficaBalance"></div>

        </div>
          <div class="tarjeta-contenedor-notas">
            
          </div>
      </div>

      
      <div class="contenedor-referencias-bibliograficas container text m-t-1-sm m-b-3-sm m-y-2-md">
        <div class="encabezado"><h2>Referencias bibliográficas</h2></div>
        <ul class="lista-referencias">
          <li><strong><em>Palacios, R., Valles, X., Solís, A., Becerril, A. S., Rodríguez, F., Martínez, H., Rodríguez, J. I., De La Pascua, L. E., Pleitez, R. O., Hernández, F., & Zamudio, J. P. (2022).</em></strong> Estudio del Balance Nacional de Energía 2020. Consejo Nacional de Ciencia y Tecnología (Conacyt), Plataforma Nacional Energía Ambiente y Sociedad (Planeas), Programa Nacional Estratégico de Energía y Cambio Climático (Pronaces-ecc). <a href="https://conacyt.mx/publicaciones-conacyt/energia-y-cambio-climatico/" target="_blank">https://conacyt.mx/publicaciones-conacyt/energia-y-cambio-climatico/</a></li>
        </ul>            
      </div>


  </div>

</template>
<script>

  import * as d3 from 'd3';
  import { sankey, sankeyLinkHorizontal } from 'd3-sankey';
  
  

  import * as am4core from "@amcharts/amcharts4/core";
  import * as am4charts from "@amcharts/amcharts4/charts";
  import am4lang_es_ES from "@amcharts/amcharts4/lang/es_ES";
  import am4themes_kelly from "@amcharts/amcharts4/themes/kelly";

  am4core.useTheme(am4themes_kelly);
  

  export default {
    name: 'App',
    components: {
    },
    data: function () {
      return {
        datosProduccion:datosProduccion,
        datosOfertaInterna:datosOfertaInterna,
        edgeToRemove: null,
        items: {
            nodes: [
              { node: 1, name: 'Producción', id: 'node9', color: '#999' },
              { node: 2, name: 'Importación', id: 'node10', color: '#999' },
              { node: 3, name: 'Exportación' , id: 'node11', color: '#999' },
              { node: 7, name: 'Petróleo', id: 'node5', color: '#000000' },
              { node: 6, name: 'Carbón', id: 'node20', color: '#85200c' },
              { node: 8, name: 'Condensados', id: 'node6', color: '#f00' },
              { node: 9, name: 'Gas natural', id: 'node13', color: '#4a86e8' },
              { node: 10, name: 'Nucleoenergía', id: 'node14', color: '#9900ff' },
              { node: 11, name: 'Geoenergía', id: 'node17', color: '#783f04' },
              { node: 12, name: 'Energía eólica', id: 'node16', color: '#0000ff' },
              { node: 13, name: 'Hidroenergía', id: 'node19', color: '#0ff' },
              { node: 14, name: 'Bagazo de caña', id: 'node22', color: '#0ff' },
              { node: 15, name: 'Biogas', id: 'node23', color: '#6d9eeb' },
              { node: 16, name: 'Energía solar', id: 'node24', color: '#ff0' },
              { node: 17, name: 'Leña', id: 'node25', color: '#b45f06' },
              { node: 18, name: 'Otros', id: 'node26', color: '#999' },
              { node: 20, name: 'Consumo propio', id: 'node29', color: '#999' },
              { node: 22, name: 'Otros *', id: 'node31', color: '#999' },
              { node: 25, name: 'Sector industrial', id: 'node33', color: '#999' },
              { node: 26, name: 'Sector transporte', id: 'node34', color: '#999' },
              { node: 27, name: 'Sector agropecuario', id: 'node36', color: '#999' },
              { node: 28, name: 'Sector comercial y servicios', id: 'node8', color: '#999' },
              { node: 29, name: 'Sector público', id: 'node8', color: '#999' },
              { node: 30, name: 'Sector residencial', id: 'node8', color: '#999' },
              { node: 31, name: 'PEMEX Petroquímica', id: 'node8', color: '#999' },
              { node: 32, name: 'Otras ramas económicas', id: 'node8', color: '#999' },
              { node: 33, name: 'Hornos y coquizadoras', id: 'node8', color: '#999' },
              { node: 34, name: 'Refinerías y despuntadoras', id: 'node8', color: '#999' },
              { node: 35, name: 'Plantas de gas y fraccionadoras', id: 'node8', color: '#999' },
              { node: 36, name: 'Transferencia interproductos', id: 'node8', color: '#999' },
              { node: 37, name: 'Coque de carbón', id: 'node8', color: '#cc4125' },
              { node: 38, name: 'Coque de petróleo', id: 'node8', color: '#000000' },
              { node: 39, name: 'Combustóleo', id: 'node8', color: '#666666' },
              { node: 40, name: 'Queroseno', id: 'node8', color: '#999' },
              { node: 41, name: 'Diésel', id: 'node8', color: '#b7b7b7' },
              { node: 42, name: 'Gasolina', id: 'node8', color: '#cccccc' },
              { node: 43, name: 'GLP', id: 'node8', color: '#c9daf8' },
              { node: 44, name: 'Gas seco', id: 'node8', color: '#6d9eeb' },
              { node: 45, name: 'No energéticos', id: 'node8', color: '#ff00ff' },
              { node: 46, name: 'Pérdidas en transformación', id: 'node8', color: '#999' },
              { node: 47, name: 'Centrales eléctricas', id: 'node8', color: '#00ff00' },
              { node: 47, name: 'Electricidad', id: 'node8', color: '#00ff00' }
            ],
            links: [
              
              { source: "Producción", target: "Carbón", value: 192.29, color: "#85200c"},
              { source: "Producción", target: "Petróleo", value: 3821.1, color: "#000000"},
              { source: "Producción", target: "Gas natural", value: 2553, color: "#4a86e8"},
              { source: "Producción", target: "Condensados", value: 140.98, color: "#f00"},
              { source: "Producción", target: "Nucleoenergía", value: 125.62, color: "#9900ff"},
              { source: "Producción", target: "Geoenergía", value: 18.54, color: "#783f04"},
              { source: "Producción", target: "Hidroenergía", value: 96.52, color: "#0ff"},
              { source: "Producción", target: "Energía eólica", value: 70.9, color: "#0000ff"},
              { source: "Producción", target: "Bagazo de caña", value: 99.66, color: "#0ff"},
              { source: "Producción", target: "Biogas", value: 2.53, color: "#6d9eeb"},
              { source: "Producción", target: "Leña", value: 246.62, color: "#b45f06"},
              { source: "Producción", target: "Energía solar", value: 72.75, color: "#ff0"},


              { source: "Carbón", target: "Exportación", value: 0.09, color: "#85200c"},
              { source: "Carbón", target: "Hornos y coquizadoras", value: 27.13, color: "#85200c"},
              { source: "Carbón", target: "Sector industrial", value: 20.95, color: "#85200c"},
              { source: "Carbón", target: "Centrales eléctricas", value: 164.1, color: "#85200c"},
              { source: "Carbón", target: "Otros", value: 1.81, color: "#85200c"},

              { source: "Petróleo", target: "Exportación", value: 2509.2, color: "#000000"},
              { source: "Petróleo", target: "Refinerías y despuntadoras", value: 1303.1, color: "#000000"},
              { source: "Petróleo", target: "Consumo propio", value: 16.82, color: "#000000"},

              { source: "Condensados", target: "Plantas de gas y fraccionadoras", value: 7.26, color: "#F00"},
              { source: "Condensados", target: "Otros", value: 133.72, color: "#F00"},

              { source: "Gas natural", target: "Plantas de gas y fraccionadoras", value: 1072.7, color: "#4a86e8"},
              { source: "Gas natural", target: "Consumo propio", value: 641.15, color: "#4a86e8"},
              { source: "Gas natural", target: "Transferencia interproductos", value: 134.9, color: "#4a86e8"},
              { source: "Gas natural", target: "Otros", value: 704.34, color: "#4a86e8"},

              { source: "Nucleoenergía", target: "Centrales eléctricas", value: 125.62, color: "#9900ff"},

              { source: "Geoenergía", target: "Centrales eléctricas", value: 18.539, color: "#783f04"},

              { source: "Energía eólica", target: "Centrales eléctricas", value: 70.9, color: "#0000ff"},

              { source: "Hidroenergía", target: "Centrales eléctricas", value: 95.52, color: "#0ff"},

              { source: "Bagazo de caña", target: "Otros", value: 1.1, color: "#f6b26b"},
              { source: "Bagazo de caña", target: "Centrales eléctricas", value: 57.82, color: "#f6b26b"},
              { source: "Bagazo de caña", target: "Sector industrial", value: 40.6, color: "#f6b26b"},

              { source: "Biogas", target: "Centrales eléctricas", value: 2.53, color: "#6d9eeb"},

              { source: "Energía solar", target: "Centrales eléctricas", value: 56.48, color: "#ffff00"},
              { source: "Energía solar", target: "Sector industrial", value: 1.3, color: "#ffff00"},
              { source: "Energía solar", target: "Sector comercial y servicios", value: 5.96, color: "#ffff00"},
              { source: "Energía solar", target: "Sector residencial", value: 9.01, color: "#ffff00"},

              { source: "Leña", target: "Sector residencial", value: 246.62, color: "#b45f06"},
              
              { source: "Hornos y coquizadoras", target: "Coque de carbón", value: 18.47, color: "#cc4125"},
              { source: "Hornos y coquizadoras", target: "Pérdidas en transformación", value: 8.66, color: "#f9a145"},

              { source: "Refinerías y despuntadoras", target: "Coque de petróleo", value: 99.27, color: "#434343"},
              { source: "Refinerías y despuntadoras", target: "Combustóleo", value: 417.32, color: "#666666"},
              { source: "Refinerías y despuntadoras", target: "Diésel", value: 220.49, color: "#b7b7b7"},
              { source: "Refinerías y despuntadoras", target: "Gasolina", value: 357.7, color: "#cccccc"},
              { source: "Refinerías y despuntadoras", target: "GLP", value: 8.43, color: "#c9daf8"},
              { source: "Refinerías y despuntadoras", target: "No energéticos", value: 29.4, color: "#ff00ff"},
              { source: "Refinerías y despuntadoras", target: "Gas seco", value: 76.64, color: "#6d9eeb"},
              { source: "Refinerías y despuntadoras", target: "Pérdidas en transformación", value: 57.06, color: "#FBFBFB"},
              { source: "Refinerías y despuntadoras", target: "Queroseno", value: 36.83, color: "#999"},
              
              { source: "Plantas de gas y fraccionadoras", target: "Pérdidas en transformación", value: 2.24, color: "#FBFBFB"},
              { source: "Plantas de gas y fraccionadoras", target: "No energéticos", value: 70.8, color: "#ff00ff"},
              { source: "Plantas de gas y fraccionadoras", target: "Gas seco", value: 783.46, color: "#6d9eeb"},
              { source: "Plantas de gas y fraccionadoras", target: "GLP", value: 144.27, color: "#c9daf8"},
              { source: "Plantas de gas y fraccionadoras", target: "Gasolina", value: 79.51, color: "#cccccc"},

              { source: "Transferencia interproductos", target: "Gas seco", value: 134.9, color: "#6d9eeb"},

              { source: "Importación", target: "Carbón", value: 21.79, color: "#85200c"},
              { source: "Importación", target: "Gas seco", value: 1890.4, color: "#6d9eeb"},
              { source: "Importación", target: "Gasolina", value: 649.31, color: "#cccccc"},
              { source: "Importación", target: "GLP", value: 283, color: "#c9daf8"},
              { source: "Importación", target: "Diésel", value: 436.23, color: "#b7b7b7"},
              { source: "Importación", target: "Combustóleo", value: 20.2, color: "#666666"},
              { source: "Importación", target: "Electricidad", value: 35.87, color: "#00ff00"},
              { source: "Importación", target: "Coque de carbón", value: 27.2, color: "#cc4125"},
              { source: "Importación", target: "Coque de petróleo", value: 113.55, color: "#434343"},
              { source: "Importación", target: "Queroseno", value: 45.81, color: "#999"},

              

              { source: "Coque de carbón", target: "Sector industrial", value: 44.56, color: "#cc4125"},
              { source: "Coque de carbón", target: "Consumo propio", value: 1.11, color: "#cc4125"},

              { source: "Coque de petróleo", target: "Otros", value: 48.27, color: "#434343"},
              { source: "Coque de petróleo", target: "Centrales eléctricas", value: 37.84, color: "#434343"},
              { source: "Coque de petróleo", target: "Exportación", value: 0.07, color: "#434343"},
              { source: "Coque de petróleo", target: "Sector industrial", value: 126.63, color: "#434343"},

              { source: "Combustóleo", target: "Exportación", value: 262.87, color: "#666666"},
              { source: "Combustóleo", target: "Sector industrial", value: 11.72, color: "#666666"},
              { source: "Combustóleo", target: "Consumo propio", value: 37.35, color: "#666666"},
              { source: "Combustóleo", target: "Centrales eléctricas", value: 137.69, color: "#666666"},
              { source: "Combustóleo", target: "Sector transporte", value: 2.09, color: "#666666"},

              { source: "Queroseno", target: "Sector transporte", value: 106.68, color: "#999"},
              { source: "Queroseno", target: "Otros", value: 1.51, color: "#999"},

              { source: "Diésel", target: "Sector transporte", value: 438.34, color: "#b7b7b7"},
              { source: "Diésel", target: "Sector agropecuario", value: 127.34, color: "#b7b7b7"},
              { source: "Diésel", target: "Exportación", value: 36.6, color: "#b7b7b7"},
              { source: "Diésel", target: "Centrales eléctricas", value: 24.32, color: "#b7b7b7"},
              { source: "Diésel", target: "Consumo propio", value: 41.48, color: "#b7b7b7"},
              { source: "Diésel", target: "Sector industrial", value: 62.2, color: "#b7b7b7"},

              { source: "Gasolina", target: "Sector transporte", value: 1404.2, color: "#cccccc"},
              { source: "Gasolina", target: "Sector industrial", value: 1.47, color: "#cccccc"},
              { source: "Gasolina", target: "Exportación", value: 23.49, color: "#cccccc"},

              { source: "GLP", target: "Sector transporte", value: 61.04, color: "#c9daf8"},
              { source: "GLP", target: "Sector comercial y servicios", value: 61.04, color: "#c9daf8"},
              { source: "GLP", target: "Sector industrial", value: 46.34, color: "#c9daf8"},
              { source: "GLP", target: "Sector residencial", value: 240.14, color: "#c9daf8"},
              { source: "GLP", target: "Sector agropecuario", value: 4.9, color: "#c9daf8"},
              { source: "GLP", target: "Exportación", value: 1.21, color: "#c9daf8"},
              { source: "GLP", target: "Otras ramas económicas", value: 6.62, color: "#c9daf8"},
              { source: "GLP", target: "Otros", value: 14.4, color: "#c9daf8"},

              { source: "Gas seco", target: "Sector industrial", value: 438.81, color: "#6d9eeb"},
              { source: "Gas seco", target: "PEMEX Petroquímica", value: 12.05, color: "#6d9eeb"},
              { source: "Gas seco", target: "Sector comercial y servicios", value: 9.5, color: "#6d9eeb"},
              { source: "Gas seco", target: "Sector transporte", value: 1.81, color: "#6d9eeb"},
              { source: "Gas seco", target: "Exportación", value: 2.66, color: "#6d9eeb"},
              { source: "Gas seco", target: "Sector residencial", value: 25.95, color: "#6d9eeb"},
              { source: "Gas seco", target: "Consumo propio", value: 14.4, color: "#6d9eeb"},
              { source: "Gas seco", target: "Centrales eléctricas", value: 1439, color: "#6d9eeb"},
              
              
              { source: "No energéticos", target: "Consumo propio", value: 68.06, color: "#ff00ff"},
              { source: "No energéticos", target: "Otras ramas económicas", value: 30.4, color: "#ff00ff"},
              { source: "No energéticos", target: "Otros", value: 1.66, color: "#ff00ff"},

              { source: "Centrales eléctricas", target: "Electricidad", value: 1186.9, color: "#00ff00"},
              { source: "Centrales eléctricas", target: "Pérdidas en transformación", value: 1044.5, color: "#f9a145"},


              { source: "Electricidad", target: "Sector industrial", value: 635.85, color: "#00ff00"},
              { source: "Electricidad", target: "Consumo propio", value: 199.6, color: "#00ff00"},
              { source: "Electricidad", target: "Sector residencial", value: 248.32, color: "#00ff00"},
              { source: "Electricidad", target: "Sector público", value: 14.26, color: "#00ff00"},
              { source: "Electricidad", target: "Sector transporte", value: 3.41, color: "#00ff00"},
              { source: "Electricidad", target: "Sector comercial y servicios", value: 49.48, color: "#00ff00"},
              { source: "Electricidad", target: "Sector agropecuario", value: 50.4, color: "#00ff00"},
              { source: "Electricidad", target: "Exportación", value: 21.44, color: "#00ff00"},

              { source: "Otros *", target: "Diésel", value: 7.56, color: "#b7b7b7"},
              { source: "Otros *", target: "Gasolina", value: 344.06, color: "#cccccc"},
              { source: "Otros *", target: "Gas seco", value: 99.8, color: "#6d9eeb"},
              { source: "Otros *", target: "Combustóleo", value: 14.2, color: "#666666"},
              { source: "Otros *", target: "Queroseno", value: 25.54, color: "#999"},


            ],
        },
      }   
    },
    mounted() {

      const { items } = this;
      const width = 800;
      const height = 600;
      const nodeWidth = 15;
      const nodeHeight = 20;
      const nodePadding = 10;

      const ENABLE_LINKS_GRADIENTS = false;

      const svg = d3
      .select(this.$refs.svg)
      .attr('viewBox', [0, -20, width, height + 20]);

      const { nodes, links } = sankey()
        .nodeId((d) => d.name)
        .nodeWidth(nodeWidth)
        .nodeSort(false)
        .nodePadding(nodePadding)
        .extent([
          [1, 1],
          [width, height - nodeHeight],
        ])(items);
        

      const link = svg
        .append('g')
        .attr('fill', 'none')
        .attr('stroke-opacity', 0.7)
        .selectAll('g')
        .data(links)
        .join('g')
        .style("mix-blend-mode", "multiply");
      
      if (ENABLE_LINKS_GRADIENTS) {
         const gradient = link
          .append("linearGradient")
          .attr("id", (d) => d.id)
          .attr("gradientUnits", "userSpaceOnUse")
          .attr("x1", (d) => d.source.x1)
          .attr("x2", (d) => d.target.x0);

        gradient
          .append("stop")
          .attr("offset", "0%")
          .attr("stop-color", (d) => d.source.color);

        gradient
          .append("stop")
          .attr("offset", "100%")
          .attr("stop-color", (d) => d.target.color);
      }

      let tooltip = d3.select('#sankey-biomasa')
      .append("div")
        .style("position", "absolute")
        .style("visibility", "hidden")
        .style("border", "1px solid #333")
        //.style("font-family", "Arial")
        .style("font-size", "10pt")
        .style("font-weight", "bold")
        .style("max-width", "200px")
        .style("padding", "5px")
        .style("background-color", "#FFF")
        .text("Tooltip");

      link
        .append('path')
        .attr('d', sankeyLinkHorizontal())
        .attr('stroke', (d) =>
          d.color 
        )
        .attr('stroke-width', (d) => Math.max(1, d.width))
        .attr('opacity', '0.5')
        .on('mouseover', function (d, i) {
            d3.select(this).transition()
                .duration('50')
                .attr('opacity', '1');
            tooltip.style("background-color", i.color)
            tooltip.style("color", i.color == '#000000' ? '#FFF' : '#000')
            tooltip.text(''+i.source.name + ' → ' + i.target.name  + ' : ' + i.value +' MtMS/año' )
            tooltip.style("visibility", "visible");
        })
        .on('mouseout', function (d, i) {
            d3.select(this).transition()
                .duration('50')
                .attr('opacity', '0.5');
            tooltip.style("visibility", "hidden");
        })
        .on("mousemove", function(d,i){
          return tooltip.style("top", (d.pageY+10)+"px").style("left",(d.pageX+10)+"px");
        });

      /*link
        .append('title')
        .text((d) => `${d.source.name} → ${d.target.name}\n${d.value} MtMS/año`);*/

      svg
        .append('g')
        //.attr('font-family', 'sans-serif') //Quitar para dejar fuente general
        .attr('font-size', 9)
        .attr('font-weight', 'bold')
        .selectAll('text')
        .data(nodes)
        .join("text")
        .attr("x", d => d.x0 < width / 2 ? d.x1 + 6 : d.x0 - 6)
        .attr("y", d => (d.y1 + d.y0) / 2)
        .attr("dy", "0.35em")
        .attr("text-anchor", d => d.x0 < width / 2 ? "start" : "end")
        .text(d => d.name)
        .attr('class','node-text-rect')
        .attr("id", function(d, i) {
            d.id = i;
            return "rect-text-" + i;
        })
        .append("tspan")
          .attr('font-size', 9)
          .attr("fill-opacity", 0.7)
          .text(d => ` (${d.value.toLocaleString()})`);

      svg
        .append('g')
        //.attr('stroke', '#333')
        //.attr('stroke-width', '0.75')
        .selectAll('rect')
        .data(nodes)
        .join('rect')
          .attr("x", d => d.x0 + 1)
          .attr("y", d => d.y0)
          .attr("height", d => d.y1 - d.y0)
          .attr("width", d => d.x1 - d.x0 - 2)
          .attr('fill', (d) => d.color)
          .attr('class','node-rect')
          .attr("id", function(d, i) {
            d.id = i;
            return "rect-" + i;
          })
          .on("mouseover", function(d, i) {
            
            let nodeHiglight = [];

            link
              .transition()
              .duration(300)
              .style("stroke-opacity", function(l) {
                
                if(l.source.index === i.index || l.target.index === i.index) 
                {
                  nodeHiglight.push(l.target.id);
                  nodeHiglight.push(l.source.id);
                }

                return l.source.index === i.index || l.target.index === i.index ? 1 : 0.2;
              });

            tooltip.style("background-color", i.color)
            tooltip.style("color", i.color == '#000000' ? '#FFF' : '#000')
            tooltip.text(''+i.name + ' : ' + i.value.toLocaleString() +' MtMS/año' )
            tooltip.style("visibility", "visible")

            d3.selectAll(".node-rect").style("opacity", 0.2);
            d3.selectAll(".node-text-rect").style("opacity", 0.2);
            for(var i=0; i< nodeHiglight.length; i++)
            {
              d3.select('#rect-' + nodeHiglight[i]).style("opacity", 1)
              d3.select('#rect-text-' + nodeHiglight[i]).style("opacity", 1)
            }

          })
          .on("mouseleave", function(d, i) {
            link
              .transition()
              .duration(300)
              .style("stroke-opacity", 0.5);

            d3.selectAll(".node-text-rect").style("opacity", 1);
            d3.selectAll(".node-rect").style("opacity", 1);
            tooltip.style("visibility", "hidden");  
          })
          .on("mousemove", function(d,i){
            return tooltip.style("top", (d.pageY+10)+"px").style("left",(d.pageX+10)+"px");
          })
          //.append('title')
          //.text((d) => `${d.name}\n${d.value} MtMS/año`)
          ;
        
        


        let chart = am4core.create("graficaBalance", am4charts.XYChart);
        chart.hiddenState.properties.opacity = 0; // this makes initial fade in effect
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "BalanceNacionalEnergia";
        chart.exporting.useWebFonts = false;
        chart.language.locale = am4lang_es_ES;
        chart.language.locale["_decimalSeparator"] = ".";
        chart.language.locale["_thousandSeparator"] = ","; 
        // using math in the data instead of final values just to illustrate the idea of Waterfall chart
        // a separate data field for step series is added because we don't need last step (notice, the last data item doesn't have stepValue)
        chart.data = [ 
          {
            category: "Producción *",
            value: 7440.61,
            open: 0,
            stepValue: 7440.61,
            color: chart.colors.getIndex( 1 ),
            displayValue: 7440.61
          },
          {
            category: "Importación",
            value: 7440.61 + 3568.41,
            open: 7440.61,
            stepValue: 7440.61 + 3568.41,
            color: chart.colors.getIndex( 2 ),
            displayValue: 3568.41
          },
          {
            category: "Exportación",
            value: 8151.35 + 2857.67,
            open: 8151.35,
            stepValue: 8151.35 + 2857.67,
            color: chart.colors.getIndex( 3),
            displayValue: 2857.67
          },
          {
            category: "Otros **",
            value: 7585.76 + 565.59,
            open: 7585.76,
            stepValue: 7585.76 + 565.59,
            color: chart.colors.getIndex( 4 ),
            displayValue: 565.59
          },
          {
            category: "Oferta\ninterna\n bruta",
            value: 7585.76,
            open: 0,
            stepValue: 7585.76,
            color: chart.colors.getIndex( 5 ),
            displayValue: 7585.76
          },
          {
            category: "Pérdidas***",
            value: 4590.22 + 2995.54,
            open: 4590.22,
            stepValue: 4590.22 + 2995.54,
            color: chart.colors.getIndex( 6 ),
            displayValue: 2995.54
          },
          {
            category: "Consumo\nfinal",
            value: 0 + 4590.22,
            open: 0,
            stepValue: 0 + 4590.22,
            color: chart.colors.getIndex( 7 ),
            displayValue: 4590.22
          },
          {
            category: "Pérdidas***",
            value: 4590.22 + 2995.54,
            open: 4590.22,
            stepValue: 4590.22 + 2995.54,
            color: chart.colors.getIndex( 8 ),
            displayValue: 2995.54
          },
          {
            category: "Consum\nfinal\nno energético",
            value: 4540.99 + 49.23,
            open: 4540.99,
            stepValue: 4540.99 + 49.23,
            color: chart.colors.getIndex( 9 ),
            displayValue: 49.23
          },
          {
            category: "Consum\nfinal\nenergético",
            value: 0 + 4540.98,
            open: 0,
            stepValue: 0 + 4540.98,
            color: chart.colors.getIndex( 10 ),
            displayValue: 4540.98
          },
          {
            category: "Transporte",
            value: 2523.39 + 2017.59,
            open: 2523.39,
            stepValue: 2523.39 + 2017.59,
            color: chart.colors.getIndex(11 ),
            displayValue: 2017.59
          },
          {
            category: "Industrial",
            value: 1092.95 + 1430.44,
            open: 1092.95,
            stepValue: 1092.95 + 1430.44,
            color: chart.colors.getIndex( 12 ),
            displayValue: 1430.44
          },
          {
            category: "Residencial",
            value: 322.91 + 770.04,
            open: 322.91,
            stepValue: 322.91 + 770.04,
            color: chart.colors.getIndex( 13 ),
            displayValue: 770.04
          },
          {
            category: "Agropecuario",
            value: 140.24 + 182.67,
            open: 140.24,
            stepValue: 140.24 + 182.67,
            color: chart.colors.getIndex( 14 ),
            displayValue: 182.67
          },
          {
            category: "Comercial",
            value: 14.26 + 125.98,
            open: 14.26,
            stepValue: 14.26 + 125.98,
            color: chart.colors.getIndex( 15 ),
            displayValue: 125.98
          },
          {
            category: "Público",
            value: 0 + 14.26,
            open: 0,
            stepValue: 14.26 + 14.26,
            color: chart.colors.getIndex( 16 ),
            displayValue: 14.26
          },
        ];


        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "category";
        categoryAxis.renderer.minGridDistance = 40;
        categoryAxis.renderer.labels.template.fontSize = 9;

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = "PJ";
        valueAxis.min = 0;
        valueAxis.fontSize = 11;
        valueAxis.calculateTotals = true;

        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.dataFields.categoryX = "category";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.openValueY = "open";
        columnSeries.fillOpacity = 0.8;
        columnSeries.sequencedInterpolation = true;
        columnSeries.interpolationDuration = 1500;


        let columnTemplate = columnSeries.columns.template;
        columnTemplate.strokeOpacity = 0;
        columnTemplate.propertyFields.fill = "color";

        let label = columnTemplate.createChild(am4core.Label);
        label.text = "{displayValue.formatNumber('#,##')}";
        label.align = "center";
        label.fontSize = 11;
        label.valign = "middle";


        let stepSeries = chart.series.push(new am4charts.StepLineSeries());
        stepSeries.dataFields.categoryX = "category";
        stepSeries.dataFields.valueY = "stepValue";
        stepSeries.noRisers = true;
        stepSeries.stroke = new am4core.InterfaceColorSet().getFor("alternativeBackground");
        stepSeries.strokeDasharray = "3,3";
        stepSeries.interpolationDuration = 2000;
        stepSeries.sequencedInterpolation = true;

        // because column width is 80%, we modify start/end locations so that step would start with column and end with next column
        stepSeries.startLocation = 0.1;
        stepSeries.endLocation = 1.1;

        chart.cursor = new am4charts.XYCursor();
        chart.cursor.behavior = "none";

        this.chart = chart;
        
    
      

    },
    methods: {
    },  
    beforeDestroy() {
      
      if (this.chart) {
        this.chart.dispose();
      }

    },
  }

const datosProduccion = [
  {
    "nombre": "Carbón",
    "cantidad": 192.29,
    "color": "#85200c"
  },
  {
    "nombre": "Petróleo crudo",
    "cantidad": "3,821.13",
    "color": "#000000"
  },
  {
    "nombre": "Condensados",
    "cantidad": 140.98,
    "color": "#ff0000"
  },
  {
    "nombre": "Gas natural",
    "cantidad": "2,553.09",
    "color": "#4a86e8"
  },
  {
    "nombre": "Nucleoenergía",
    "cantidad": 125.62,
    "color": "#9900ff"
  },
  {
    "nombre": "Hidroenergía",
    "cantidad": 96.52,
    "color": "#00ffff"
  },
  {
    "nombre": "Geoenergía",
    "cantidad": 18.54,
    "color": "#783f04"
  },
  {
    "nombre": "Energía solar",
    "cantidad": 72.75,
    "color": "#ffff00"
  },
  {
    "nombre": "Energía eólica",
    "cantidad": 70.88,
    "color": "#0000ff"
  },
  {
    "nombre": "Bagazo de caña",
    "cantidad": 99.66,
    "color": "#f6b26b"
  },
  {
    "nombre": "Leña",
    "cantidad": 246.62,
    "color": "#b45f06"
  },
  {
    "nombre": "Biogás",
    "cantidad": 2.53,
    "color": "#6d9eeb"
  }
];

const datosOfertaInterna = [
  {
    "nombre": "Carbón",
    "cantidad": 212.18,
    "color": "#85200c"
  },
  {
    "nombre": "Petróleo crudo",
    "cantidad": "1,319.95",
    "color": "#000000"
  },
  {
    "nombre": "Condensados",
    "cantidad": 7.26,
    "color": "#ff0000"
  },
  {
    "nombre": "Gas natural",
    "cantidad": "1,848.75",
    "color": "#4a86e8"
  },
  {
    "nombre": "Nucleoenergía",
    "cantidad": 125.62,
    "color": "#9900ff"
  },
  {
    "nombre": "Hidroenergía",
    "cantidad": 96.52,
    "color": "#00ffff"
  },
  {
    "nombre": "Geoenergía",
    "cantidad": 18.54,
    "color": "#783f04"
  },
  {
    "nombre": "Energía solar",
    "cantidad": 72.75,
    "color": "#ffff00"
  },
  {
    "nombre": "Energía eólica",
    "cantidad": 70.88,
    "color": "#0000ff"
  },
  {
    "nombre": "Bagazo de caña",
    "cantidad": 98.56,
    "color": "#f6b26b"
  },
  {
    "nombre": "Leña",
    "cantidad": 246.62,
    "color": "#b45f06"
  },
  {
    "nombre": "Biogás",
    "cantidad": 2.53,
    "color": "#6d9eeb"
  },
  {
    "nombre": "Coque de carbón",
    "cantidad": 27.2,
    "color": "#cc4125"
  },
  {
    "nombre": "Coque de petróleo",
    "cantidad": 65.2,
    "color": "#434343"
  },
  {
    "nombre": "GLP",
    "cantidad": 267.38,
    "color": "#c9daf8"
  },
  {
    "nombre": "Gasolinas y naftas",
    "cantidad": 816.42,
    "color": "#cccccc"
  },
  {
    "nombre": "Querosenos",
    "cantidad": 44.3,
    "color": "#999999"
  },
  {
    "nombre": "Diésel",
    "cantidad": 473.19,
    "color": "#b7b7b7"
  },
  {
    "nombre": "Combustóleo",
    "cantidad": -228.46,
    "color": "#666666"
  },
  {
    "nombre": "Productos no energéticos",
    "cantidad": -1.66,
    "color": "#ff00ff"
  },
  {
    "nombre": "Gas seco",
    "cantidad": "1,987.58",
    "color": "#6d9eeb"
  },
  {
    "nombre": "Electricidad",
    "cantidad": 14.43,
    "color": "#00ff00"
  }
];

</script>
<style scoped lang="scss">

#graficaBalance
{
  width: 100%;
  height: 450px;
}

.node-text-rect 
{
  max-width: 60px;
}

</style>
